"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var Notifier_1 = require("../../../../../../resources/js/assets/Notifier");
var axios_1 = require("axios");
var $ = require("jquery");
var notifier = new Notifier_1.default('');
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.url = '';
        _this_1.animated = false;
        _this_1.user = {
            email: null,
            password: null,
            remember: false,
        };
        return _this_1;
    }
    LoginForm.prototype.login = function () {
        var _this_1 = this;
        var _this = this;
        _this.$validator.validateAll()
            .then(function (result) {
            if (result) {
                $('.loader').show();
                axios_1.default.post(_this_1.input_route, _this_1.user)
                    .then(function (response) {
                    $('.loader').hide();
                    $('.header').hide();
                    notifier.success('You\'re successfully logged in!', '', '');
                    if (response.data.note) {
                        var noteModal = $('#noteModal');
                        noteModal.modal('show');
                    }
                    else {
                        window.location.replace('/executive-digest');
                    }
                })
                    .catch(function (error) {
                    $('.loader').hide();
                    var message = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
                    notifier.error(message, '', '');
                });
            }
        })
            .then(function (error) {
            _this_1.animated = true;
            setTimeout(function () { return _this_1.animated = false; }, 1000);
        });
    };
    LoginForm.prototype.showForgotModal = function () {
        var pass = $('#passModal');
        pass.modal('show');
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)()
    ], LoginForm.prototype, "input_route", void 0);
    LoginForm = __decorate([
        (0, vue_property_decorator_1.Component)({
            mounted: function () {
                this.url = this.input_route.replace(/^.*\/\/[^\/]+/, '');
            }
        })
    ], LoginForm);
    return LoginForm;
}(vue_property_decorator_1.Vue));
exports.default = LoginForm;
